/*
 * i18next configuration for React components
 */

import en from '../../../i18n/en.json';
import es from '../../../i18n/es.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { applyMomentLocale } from '../bootstrap/appInit';

const resources = {
    en: { translation: en },
    es: { translation: es }
};

const resolveInitialLanguage = () => {
    try {
        const raw = localStorage.getItem('ngStorage-happyForceUser');
        if (raw) {
            const user = JSON.parse(raw);
            if (user?.language) {
                return user.language;
            }
        }
    } catch {
        // ignore parse errors
    }

    try {
        return localStorage.getItem('NG_TRANSLATE_LANG_KEY') || 'en';
    } catch {
        return 'en';
    }
};

// Initialize i18next for React components
const i18nForMigration = i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: resolveInitialLanguage(),
        fallbackLng: 'en',
        debug: false,

        interpolation: {
            escapeValue: false,
            prefix: '{{',
            suffix: '}}'
        },

        react: {
            useSuspense: false,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'p', 'span', 'div', 'a']
        },

        defaultNS: 'translation',
        ns: ['translation'],

        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage']
        }
    });

export default i18nForMigration;

export const getCurrentLanguage = () => {
    return i18n.language;
};

export const changeLanguage = (lang) => {
    if (!lang) {
        return;
    }
    i18n.changeLanguage(lang);
    applyMomentLocale(lang);
};

export const initializeI18nLanguage = () => {
    const lang = resolveInitialLanguage();
    if (lang && lang !== i18n.language) {
        i18n.changeLanguage(lang);
    }
    applyMomentLocale(lang || i18n.language || 'en');
};
